import { useState } from "react";
import styled, { keyframes } from "styled-components";
import MailLogo from "../../../assets/images/icons/facebook.webp";
import WechatIcon from "../../../assets/images/icons/wechat.webp";
import WhatsappIcon from "../../../assets/images/icons/whatsapp.webp";
import { Theme } from "../../themes/theme";

const fadeSlideIn = keyframes`
  from { opacity: 0; transform: translateX(10px); }
  to   { opacity: 1; transform: translateX(0); }
`;

const Wrapper = styled.div`
  position: fixed;
  right: 20px;
  top: 80px;
  z-index: 1000;
`;

const OuterShell = styled.div`
  background: #ffffff;
  border-radius: 999px;
  padding: 8px 6px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-shadow: ${Theme.shadow.card};
`;

const IconBtn = styled.a`
  position: relative;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: ${Theme.color.background.light};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-decoration: none;
  transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);

  &:hover {
    transform: translateY(-1px);
  }
`;

const LogoContainer = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const LogoImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const Tooltip = styled.div`
  position: absolute;
  right: calc(100% + 18px);
  top: 50%;
  transform: translateY(-50%);
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-radius: 14px;
  padding: 14px;
  pointer-events: none;
  animation: ${fadeSlideIn} 0.18s ease forwards;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.12);
  white-space: nowrap;

  &::after {
    content: "";
    position: absolute;
    right: -6px;
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
    width: 11px;
    height: 11px;
    background: #ffffff;
    border-top: 1px solid rgba(0, 0, 0, 0.07);
    border-right: 1px solid rgba(0, 0, 0, 0.07);
  }
`;

const TooltipLabel = styled.p`
  margin: 0 0 10px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.35);
  font-family: sans-serif;
  display: none;
`;

const QRImage = styled.img`
  width: 130px;
  height: 130px;
  border-radius: 8px;
  display: block;
`;

const EmailText = styled.p`
  margin: 0;
  font-size: 13px;
  color: #111;
  font-family: sans-serif;
`;

const SOCIALS = [
  {
    id: "wechat",
    icon: WechatIcon,
    href: "weixin://",
    tooltip: (
      <>
        <TooltipLabel>WeChat</TooltipLabel>
        <QRImage src={"WechatQR"} alt="WeChat QR" />
      </>
    ),
  },
  {
    id: "whatsapp",
    icon: WhatsappIcon,
    href: "https://wa.me/1234567890",
    tooltip: (
      <>
        <TooltipLabel>WhatsApp</TooltipLabel>
        <QRImage src={"WhatsappQR"} alt="WhatsApp QR" />
      </>
    ),
  },
  {
    id: "email",
    icon: MailLogo,
    href: "mailto:hello@example.com",
    tooltip: (
      <>
        <TooltipLabel>Email</TooltipLabel>
        <EmailText>hello@example.com</EmailText>
      </>
    ),
  },
];

function FloatingSocialWidget() {
  const [hovered, setHovered] = useState(null);

  return (
    <Wrapper>
      <OuterShell>
        {SOCIALS.map(({ id, icon, href, tooltip }) => (
          <IconBtn
            key={id}
            href={href}
            target={id !== "email" ? "_blank" : undefined}
            rel="noopener noreferrer"
            onMouseEnter={() => setHovered(id)}
            onMouseLeave={() => setHovered(null)}
          >
            <LogoContainer>
              <LogoImg src={icon} alt={id} />
            </LogoContainer>
            {hovered === id && <Tooltip>{tooltip}</Tooltip>}
          </IconBtn>
        ))}
      </OuterShell>
    </Wrapper>
  );
}

export default FloatingSocialWidget;
